/* Keep the back link on a shopping page, including after a cart reload or country change. */
(function () {
  'use strict';
  var key = 'syd:last-shopping-page:v1';

  function shoppingUrl(value) {
    if (!value) return null;
    try {
      var url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      var path = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
      if (path !== '/' && !/^\/(products|collections|pages|search|blogs)(\/|$)/.test(path)) return null;
      return url.href;
    } catch (_) { return null; }
  }

  function refresh() {
    var back = document.querySelector('[data-syd-cart-back]');
    if (!back) {
      var page = shoppingUrl(window.location.href);
      if (page) { try { sessionStorage.setItem(key, page); } catch (_) {} }
      return;
    }
    var referrer = document.referrer ? shoppingUrl(document.referrer) : null;
    var stored = null;
    try { stored = shoppingUrl(sessionStorage.getItem(key) || ''); } catch (_) {}
    var target = referrer || stored;
    if (target) {
      back.href = target;
      try { sessionStorage.setItem(key, target); } catch (_) {}
    }
    if (back.dataset.sydBackBound) return;
    back.dataset.sydBackBound = 'true';
    back.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (referrer && back.href === referrer && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    });
  }

  refresh();
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();


/* Syd's House: keep the latest full basket on an already identified Klaviyo profile.
   Native Shopify Added to Cart remains the flow trigger. No cart tokens or PII are copied. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) { module.exports = api; return; }
  if (root.__shCartProfileInstalled) return;
  root.__shCartProfileInstalled = true;
  api.install(root, document);
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  function plain(value) {
    return String(value || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;|&#160;/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function fitSize(description, variant) {
    var text = plain(description), match;
    if (/one\s+size\s+(?:fits\s+all|fits\s+most)/i.test(text)) return /fits\s+most/i.test(text) ? 'One size fits most' : 'One size fits all';
    match = text.match(/fits?\s+like\s+(?:an?\s+)?(XXXL|XXL|XL|XS|XXS|S|M|L|small|medium|large|extra[ -]large|extra[ -]small)\b/i);
    if (!match) match = text.match(/\bsize\s*[:\-]?\s*(XXXL|XXL|XL|XS|XXS|S|M|L|small|medium|large|extra[ -]large|extra[ -]small)\b/i);
    var raw = match ? match[1] : String(variant || '').trim();
    var names = {XXS:'XX-Small',XS:'X-Small',S:'Small',M:'Medium',L:'Large',XL:'X-Large',XXL:'XX-Large',XXXL:'XXX-Large',SMALL:'Small',MEDIUM:'Medium',LARGE:'Large','EXTRA LARGE':'X-Large','EXTRA-LARGE':'X-Large','EXTRA SMALL':'X-Small','EXTRA-SMALL':'X-Small'};
    return names[raw.toUpperCase()] || (/^default title$/i.test(raw) ? '' : raw);
  }
  function snapshot(cart, config, now) {
    var currency = /^[A-Z]{3}$/.test(cart.currency || '') ? cart.currency : '';
    if (!currency) throw new Error('Missing cart currency');
    var origin = config.origin, country = String(config.country || '').toUpperCase();
    var format = new Intl.NumberFormat('en-GB', {style:'currency',currency:currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:0,maximumFractionDigits:2});
    var items = (cart.items || []).map(function (item) {
      var id = String(item.variant_id || item.id || '');
      if (!/^\d+$/.test(id) || !/^\d+$/.test(String(item.product_id || ''))) return null;
      var quantity = Math.max(0, Math.floor(Number(item.quantity) || 0));
      if (!quantity) return null;
      var url = new URL(item.url || '/products/' + item.handle, origin);
      if (url.origin !== origin) return null;
      var price = Number(item.final_price != null ? item.final_price : item.price) / 100;
      if (!Number.isFinite(price) || price < 0) return null;
      var title = String(item.product_title || item.title || '').replace(/\s*\((?:XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|SMALL|MEDIUM|LARGE)\)\s*$/i, '');
      var photo = item.featured_image && item.featured_image.url || item.image || '';
      if (photo.indexOf('//') === 0) photo = 'https:' + photo;
      return {product_id:String(item.product_id),variant_id:id,quantity:quantity,title:title,fit_size:fitSize(item.product_description,item.variant_title),price:price,price_display:format.format(price),line_total:Number(item.final_line_price != null ? item.final_line_price : price*100*quantity)/100,image_url:photo,url:url.href};
    }).filter(Boolean);
    if (items.length !== (cart.items || []).filter(function(i){return Number(i.quantity)>0}).length) throw new Error('Incomplete cart snapshot');
    var total = Number(cart.total_price) / 100;
    if (!Number.isFinite(total) || total < 0) throw new Error('Invalid basket value');
    var codes = [];
    function discount(application) { if (application && application.type === 'discount_code' && application.title && codes.indexOf(application.title) < 0) codes.push(application.title); }
    (cart.cart_level_discount_applications || []).forEach(discount);
    (cart.items || []).forEach(function(i){(i.line_level_discount_allocations || []).forEach(function(d){discount(d.discount_application)})});
    return {version:1,updated_at:(now || new Date()).toISOString(),country:country,currency:currency,items:items,item_count:items.reduce(function(n,i){return n+i.quantity},0),subtotal:total,free_shipping_qualified:country==='GB'||country==='US'&&currency==='USD'&&total>=175||country==='AU'&&currency==='AUD'&&total>=275,discount_codes:codes.slice(0,5),cart_root:new URL(config.cartRoot || '/cart',origin).href};
  }
  function install(win, doc) {
    // Official Klaviyo promise queue; some Shopify embeds expose only _klOnsite.
    // Creating the queue sends nothing. Consent and identification are checked below.
    if (!win.klaviyo && typeof Proxy === 'function') {
      win._klOnsite = win._klOnsite || [];
      win.klaviyo = new Proxy({}, {get:function(_, method) {
        if (method === 'push') return function(){ return win._klOnsite.push.apply(win._klOnsite, arguments); };
        return function(){
          var args = Array.prototype.slice.call(arguments);
          return new Promise(function(resolve){win._klOnsite.push([method].concat(args,[resolve]));});
        };
      }});
    }
    var script = doc.currentScript;
    var config = {origin:win.location.origin,country:script && script.dataset.shCartCountry || '',cartRoot:script && script.dataset.shCartRoot || '/cart'};
    var routeRoot = script && script.dataset.shRouteRoot || '/';
    var timer, running = false, queued = false, revision = 0, lastSignature = '', privacyReady = false;
    function report(stage) {
      if (new URLSearchParams(win.location.search).get('sh_cart_debug') !== '1') return;
      var output=doc.getElementById('sh-cart-qa');
      if (!output) { output=doc.createElement('aside'); output.id='sh-cart-qa'; output.setAttribute('role','status'); output.style.cssText='position:fixed;bottom:8px;left:8px;z-index:99999;background:#fff;color:#111;padding:8px;font:13px Arial;border:1px solid #111'; doc.body.appendChild(output); }
      output.textContent='Cart tracking QA: '+stage;
    }
    function allowed() {
      var privacy = win.Shopify && win.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed());
    }
    function schedule(delay) { revision++; clearTimeout(timer); timer = setTimeout(sync, typeof delay==='number'?delay:250); }
    async function sync() {
      if (running) { queued = true; return; }
      if (!privacyReady || !allowed()) { report('waiting for marketing consent'); return; }
      if (!win.klaviyo || typeof win.klaviyo.isIdentified !== 'function') { report('waiting for Klaviyo'); return; }
      running = true;
      var started = revision;
      try {
        report('checking visitor identity');
        var legacy = win._learnq && typeof win._learnq.isIdentified === 'function' ? win._learnq : null;
        var identified = legacy ? legacy.isIdentified() : await Promise.race([win.klaviyo.isIdentified(),new Promise(function(_,reject){setTimeout(function(){reject(new Error('Identity unavailable'));},5000);})]);
        if (!identified) { report('visitor not identified'); return; }
        report('identified visitor; reading basket');
        var response = await win.fetch(routeRoot + 'cart.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
        if (!response.ok) return;
        var data = snapshot(await response.json(), config);
        if (started !== revision || !allowed()) { queued = true; return; }
        var signature = JSON.stringify({country:data.country,currency:data.currency,items:data.items,subtotal:data.subtotal,discount_codes:data.discount_codes});
        if (signature === lastSignature) return;
        if (legacy) legacy.push(['identify',{SH_Cart:data,SH_CartItemCount:data.item_count}]);
        else await Promise.race([win.klaviyo.identify({SH_Cart:data,SH_CartItemCount:data.item_count}),new Promise(function(_,reject){setTimeout(function(){reject(new Error('Profile update unavailable'));},5000);})]);
        report('basket synced: '+data.item_count+' items '+data.currency);
        lastSignature = signature;
        doc.dispatchEvent(new CustomEvent('sh:cart-profile-synced',{detail:{itemCount:data.item_count,currency:data.currency}}));
      } catch (_) { report('sync failed'); /* A tracking failure must not affect shopping or cart actions. */ }
      finally { running = false; if (queued) { queued=false; schedule(250); } }
    }
    function ready() { privacyReady = !!(win.Shopify && win.Shopify.customerPrivacy); schedule(0); }
    if (win.Shopify && win.Shopify.customerPrivacy) ready();
    else if (win.Shopify && typeof win.Shopify.loadFeatures==='function') win.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error)ready()});
    if (typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined') subscribe(PUB_SUB_EVENTS.cartUpdate,function(){schedule()});
    if (typeof win.PerformanceObserver==='function') {
      try { new win.PerformanceObserver(function(list){
        list.getEntries().forEach(function(entry){try{var url=new URL(entry.name);if(url.origin===win.location.origin && /\/cart\/(?:add|change|update|clear)(?:\.js)?$/.test(url.pathname))schedule()}catch(_){}});
      }).observe({type:'resource',buffered:false}); } catch (_) {}
    }
    doc.addEventListener('visitorConsentCollected',function(){privacyReady=true;lastSignature='';schedule(0)});
    win.addEventListener('klaviyoForms',function(event){if(event.detail && event.detail.type==='submit'){lastSignature='';schedule(1000)}});
    win.addEventListener('pageshow',function(){lastSignature='';schedule(100)});
    win.addEventListener('focus',function(){lastSignature='';schedule(250)});
    doc.addEventListener('visibilitychange',function(){if(!doc.hidden){lastSignature='';schedule(250)}});
    [2000,5000,15000].forEach(function(delay){setTimeout(function(){if(!privacyReady)ready();schedule(0)},delay)});
  }
  return {snapshot:snapshot,fitSize:fitSize,install:install};
});
